import * as PIXI from "pixi.js";
import * as PIXI3D from "pixi3d";
import signals from "signals";


export default class App
{
    // #region Attributes //

    // private:

    private _renderer: PIXI.Renderer = null;
    private _stage: PIXI.Container = null;
    private _mainDiv: HTMLDivElement = null;
    private _gameDiv: HTMLDivElement = null;
    private _privateGameShareUrlDiv: HTMLDivElement = null;

    private _root: PIXI.Container = null;

    private _safeArea: PIXI.Container = null;
    private _mask: PIXI.Graphics = null;
    private _isTouchDevice: boolean = null;
    //private _viewportSizeViewer: ViewportSizeViewer = null;

    private _fpsText: PIXI.Text = null;

    // Binded functions.
    private _bfOnWindowResized: any = null;

    // Signals.
    private _onCopyUrlBtnClick: signals.Signal = null;
    private _onWindowResized: signals.Signal = null;

    // Constants.
    private _kSafeAreaHeight: number = 1390;
    private _kSafeAreaWidth: number = 854;
    private _kHeight: number = 1136;
    private _kWidth: number = 640;
    private _kSafeAreaMarginX: number = ( this._kSafeAreaWidth - this._kWidth ) * 0.5;
    private _kSafeAreaMarginY: number = ( this._kSafeAreaHeight - this._kHeight ) * 0.5;

    // #endregion //


    // #region Properties //

    public get renderer(): PIXI.Renderer { return this._renderer; }
    public get stage(): PIXI.Container { return this._stage; }
    public get gameDiv(): HTMLDivElement { return this._gameDiv; }
    public get root(): PIXI.Container { return this._root; }
    public get isTouchDevice(): boolean { return this._isTouchDevice; }
    public get safeArea(): PIXI.Container { return this._safeArea; }
    public get width(): number { return this._kWidth; }
    public get height(): number { return this._kHeight; }
    public get safeAreaWidth(): number { return this._kSafeAreaWidth; }
    public get safeAreaHeight(): number { return this._kSafeAreaHeight; }
    public get safeAreaMarginX(): number { return this._kSafeAreaMarginX; }
    public get safeAreaMarginY(): number { return this._kSafeAreaMarginY; }

    // Signals.
    public get onCopyUrlBtnClick() { return this._onCopyUrlBtnClick; }
    public get onWindowResized() { return this._onWindowResized; }
    
    // #endregion //


    // #region Methods //

    // public:

    public init(): void
    {
        this._onCopyUrlBtnClick = new signals.Signal();
        this._onWindowResized = new signals.Signal();

        this._isTouchDevice = false;

        // Setup body.
        document.body.style.margin = "0px";
        //document.body.style.overflow = "hidden";
        document.body.style.backgroundColor = "black";

        this._renderer = new PIXI.Renderer( {
            width: document.documentElement.clientHeight * this._kSafeAreaWidth / this._kSafeAreaHeight,
            height: document.documentElement.clientHeight,
            backgroundAlpha: 1,
            autoDensity: true,
            antialias: true,
            preserveDrawingBuffer: false,
            resolution: Math.min( window.devicePixelRatio, 2 ),
            backgroundColor: 0x000000,
            clearBeforeRender: true,
         } );
        
        let bodyDiv: HTMLElement = document.createElement( "div" );
        bodyDiv.style.position = "absolute";
        bodyDiv.style.width = "100%";
        bodyDiv.style.height = "100%";
        bodyDiv.style.overflow = "hidden";
        document.body.appendChild( bodyDiv );

        this._mainDiv = document.createElement( "div" );
        //this._mainDiv.style.width = "100%";
        this._mainDiv.style.display = "flex";
        this._mainDiv.style.justifyContent = "center";
        this._mainDiv.style.backgroundSize = "auto 100%";
        this._mainDiv.style.backgroundImage = "url(\"resources/img/background_pattern.png\")";
        this._mainDiv.style.backgroundRepeat = "repeat-x";
        bodyDiv.appendChild( this._mainDiv );
        //
        this._gameDiv = document.createElement( "div" );
        this._gameDiv.style.position = "relative";
        this._gameDiv.appendChild( this._renderer.view );
        this._privateGameShareUrlDiv = this._createPrivateGameShareUrlDiv();
        this.hidePrivateGameShareUrlDiv();
        this._gameDiv.appendChild( this._privateGameShareUrlDiv );
        this._mainDiv.appendChild( this._gameDiv );

        PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.LINEAR;

        this._stage = new PIXI.Container();
        this._stage.interactive = true;

        // Background.
        this._safeArea = new PIXI.Container();
        this._stage.addChild( this._safeArea );

        this._mask = new PIXI.Graphics();
        this._mask.beginFill( 0xffffff );
        this._mask.drawRect( -this.safeAreaWidth * 0.5, -this.safeAreaHeight * 0.5, this.safeAreaWidth, this.safeAreaHeight );
        this._mask.endFill();
        this._mask.isMask = true;
        this._stage.addChild( this._mask );

        // Game container.
        this._root = new PIXI.Container();
        this._root.mask = this._mask;
        this._stage.addChild( this._root );

        // TEST:
        // Player area.
        /*let g: PIXI.Graphics = new PIXI.Graphics();
        g.beginFill( 0xffffff, 0.5 );
        g.drawRect( 0, 0, this._kWidth, this._kHeight );
        g.endFill();
        this._root.addChild( g );*/

        /*this._viewportSizeViewer = new ViewportSizeViewer();
        this._app.stage.addChild( this._viewportSizeViewer );*/
        //

        // Listen to events.
        this._bfOnWindowResized = this._onWindow_Resized.bind( this );
        window.addEventListener( "resize", this._bfOnWindowResized );
        this._stage.once( "touchstart", () => { this._isTouchDevice = true; } );
    
        this._onWindow_Resized();
    }

        private _createPrivateGameShareUrlDiv(): HTMLDivElement
        {
            let result: HTMLDivElement = document.createElement( "div" );
            result.style.width = "799px";
            result.style.position = "absolute";
            result.style.bottom = "8px";
            result.style.textAlign = "center";
            result.style.display = "flex";
            result.style.justifyContent = "center";
            result.style.alignItems = "center";
            result.style.flexDirection = "column";
            result.style.transformOrigin = "left bottom";

            let titleDiv: HTMLDivElement = document.createElement( "div" );
            titleDiv.innerText = "Copy the link & share it with your friends";
            titleDiv.style.marginBottom = "20px";
            titleDiv.style.fontSize = "30px";
            titleDiv.style.color = "white";
            titleDiv.style.fontFamily = "jaro_regular";
            result.appendChild( titleDiv );
            //
            let urlDiv: HTMLDivElement = document.createElement( "div" );
            urlDiv.style.marginBottom = "20px";
            result.appendChild( urlDiv );
            // //
            let urlTextField: HTMLInputElement = document.createElement( "input" );
            urlTextField.type = "text";
            urlTextField.id = "shareUrlInput";
            urlTextField.style.width = "452px";
            urlTextField.style.height = "80px";
            urlTextField.style.fontSize = "24px";
            urlTextField.style.fontFamily = "jaro_regular";
            urlTextField.style.outline = "none";
            urlTextField.style.border = "none"
            urlTextField.style.whiteSpace = "nowrap";
            urlTextField.style.overflow = "hidden";
            urlTextField.style.textOverflow = "ellipsis";
            urlTextField.style.backgroundImage = "url('./resources/img/matchmaking/url_base@2x.png')";
            urlTextField.style.backgroundSize = "cover";
            urlTextField.style.backgroundPosition = "center";
            urlTextField.style.backgroundRepeat = "no-repeat";
            urlTextField.style.backgroundColor = "transparent";
            urlTextField.style.paddingLeft = "30px";
            urlTextField.style.paddingRight = "30px";
            urlTextField.style.paddingBottom = "8px";
            urlTextField.style.textAlign = "center";
            urlTextField.style.color = "white";
            urlTextField.readOnly = true;
            urlDiv.appendChild( urlTextField );
            // 
            let copyDiv: HTMLDivElement = document.createElement( "div" );
            result.appendChild( copyDiv );
            // //
            let copyUrlBtn: HTMLInputElement = document.createElement( "input" );
            copyUrlBtn.type = "image";
            copyUrlBtn.innerText = "Copy";
            copyUrlBtn.name = "copyUrlBtn";
            copyUrlBtn.src = "./resources/img/matchmaking/button_copy@2x.png";
            copyUrlBtn.style.width = "253px";
            copyDiv.appendChild( copyUrlBtn );
            copyUrlBtn.addEventListener( "mousedown", () => {
                copyUrlBtn.src = "./resources/img/matchmaking/button_copy_pressed@2x.png";
            } );
            copyUrlBtn.addEventListener( "mouseup", () => {
                copyUrlBtn.src = "./resources/img/matchmaking/button_copy@2x.png";
            } );
            copyUrlBtn.addEventListener( "mouseleave", () => {
                copyUrlBtn.src = "./resources/img/matchmaking/button_copy@2x.png";
            } );
            copyUrlBtn.addEventListener( "click", () => { this._onCopyUrlBtnClick.dispatch(); } );

            return result;
        }

    public end(): void
    {
        // Cleanup events.
        window.removeEventListener( "resize", this._bfOnWindowResized );
        this._bfOnWindowResized = null;

        this._onCopyUrlBtnClick.dispose();
        this._onCopyUrlBtnClick = null;

        //this._viewportSizeViewer = null;
        this._root = null;

        this._stage.destroy( { children: true, texture: true, baseTexture: true } );
        this._stage = null;
        
        this._renderer.destroy( true );
        this._renderer = null;
    }

    public render(): void
    {
        this._renderer.render( this._stage );
    }

    public printFPS( fps: number ): void
    {
        if ( !this._fpsText )
        {
            this._fpsText = new PIXI.Text( "", { fill: "white", stroke: "black", strokeThickness: 4 } );
            this._fpsText.position.set( 5 );
            this._stage.addChild( this._fpsText );
        }
        this._fpsText.text = Math.round( fps ).toString() + "fps";
    }

    public showPrivateGameShareUrlDiv( url: string ): void
    {
        this._privateGameShareUrlDiv.style.display = "flex";
        ( this._privateGameShareUrlDiv.querySelector( "#shareUrlInput" ) as HTMLInputElement ).value = url;
    }

    public hidePrivateGameShareUrlDiv(): void
    {
        this._privateGameShareUrlDiv.style.display = "none";
    }

    // #endregion //


    // #region Callbacks //

    private _onWindow_Resized(): void
    {
        let rendererH: number = document.documentElement.clientHeight;
        let rendererW: number = rendererH * this.safeAreaWidth / this.height;
        if ( rendererW > document.documentElement.clientWidth )
        {
            rendererW = document.documentElement.clientWidth;
        }

        this._renderer.resize( rendererW, rendererH );

        this.resizeGame( rendererW, rendererH );

        const scaleX = this._privateGameShareUrlDiv.parentElement.clientWidth / 800;   // base width
        const scaleY = this._privateGameShareUrlDiv.parentElement.clientWidth / 400;  // base height
        const scale = Math.min( scaleX, scaleY );       // keep proportions
        this._privateGameShareUrlDiv.style.transform = `scale(${scale})`;

        /*this._viewportSizeViewer.updateText( document.documentElement.clientWidth, document.documentElement.clientHeight );
        this._viewportSizeViewer.position.set( 10, document.documentElement.clientHeight - this._viewportSizeViewer.height - 10 );*/

        this._onWindowResized.dispatch( rendererW, rendererH );
    }

        private resizeGame( rendererW: number, rendererH: number ): void
        {
            let scale: number = rendererW / this.width;  
            if ( this.height * scale > rendererH )
            {
                scale = rendererH / this.height;  
            }

            this._root.scale.set( scale );  
            this._root.x = ( rendererW - this.width * scale ) * 0.5;
            this._root.y = ( rendererH - this.height * scale ) * 0.5;

            this._safeArea.position.set( rendererW * 0.5, rendererH * 0.5 );
            this._safeArea.scale.set( scale );

            this._mask.position.set( rendererW * 0.5, rendererH * 0.5 );
            this._mask.scale.set( scale );
        }

    // #endregion //
}